module.exports = __webpack_public_path__ + "static/img/ycks2.8cef1c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/appopen/appopen/ycks2.png
// module id = dAdT
// module chunks = 0